import type { ForwardRefExoticComponent, ReactNode, RefAttributes } from 'react';

import InputFormItemImpl from './InputFormItem';

export interface InputFormItemProps {
  [key: string]: any;
  label?: string;
  type?: string;
  value?: any;
  disabled?: boolean;
  error?: boolean;
  onClick?: (event: any) => void;
  onFocus?: (event: any) => void;
  onChange?: (event: any) => void;
  onBlur?: (event: any) => void;
  readonly?: boolean;
  withIcon?: ReactNode;
  autoComplete?: string;
  message?: string;
  name?: string;
}

const InputFormItem = InputFormItemImpl as unknown as ForwardRefExoticComponent<
  InputFormItemProps & RefAttributes<HTMLInputElement>
>;

export default InputFormItem;
